/* eslint-disable @typescript-eslint/no-use-before-define */
import * as React from 'react';
import {styled} from '@mui/material/styles';
import {ConfirmEmailScreenType} from '@practicegenius/register-account/src/screens/ConfirmEmail';
import {IMT, strongify} from '@practicegenius/pg-util/src/StringUtils';
import {VerificationNumberInput} from '@practicegenius/pg-ui/src/components/VerificationNumberInput';
import {SvgImage} from '../../../components/SvgImage/SvgImage';
import {Link} from '../../../components/Link';
import {ProgressScreen} from '../../../components/screens/BaseScreen';

const CODE_LENGTH = 5;

const Heading = styled('h2')({
  fontSize: '24px',
  marginTop: '40px',
  textAlign: 'center',
});

export const ConfirmEmail: ConfirmEmailScreenType = ({
  lang,
  onFormSubmit,
  progress,
  title,
  relevantEmail,
  useResponsibleEmail,
  actionButtons,
  resendEmail,
  verificationProps,
}) => (
  <form onSubmit={onFormSubmit}>
    <ProgressScreen
      helmetTitle={lang.pageTitle}
      headerTitle={lang.headerTitle}
      progress={progress}
      title={title}
      instructions={
        <span
          dangerouslySetInnerHTML={{
            __html: IMT(lang.instructions.base, {
              bold: strongify,
              primaryColor() {
                return (text: string, render: (txt: string) => string) =>
                  `<span style="color: #222222">${render(
                    text || 'placeholder'
                  )}</span>`;
              },
              relevantEmail,
              tail: useResponsibleEmail
                ? lang.instructions.useResponsibleEmailTail
                : lang.instructions.defaultTail,
            }),
          }}
        />
      }
      actionButtons={[actionButtons.primary]}
      bottomText={
        <p>
          {lang.bottomText.prompt}{' '}
          <Link href="#" onClick={resendEmail}>
            {lang.bottomText.linkText}
          </Link>
        </p>
      }
      cancelProps={{href: '/'}}
    >
      <div style={{textAlign: 'center'}}>
        <SvgImage name="emailSent" />
      </div>
      <Heading>Enter verification code</Heading>
      <VerificationNumberInput
        name="code"
        value={verificationProps.code}
        onChange={verificationProps.onChangeVerificationCode}
        codeLength={CODE_LENGTH}
        error={verificationProps.error}
      />
    </ProgressScreen>
  </form>
);
